import React from 'react';
import { useIntl } from 'react-intl';

import { FormSection } from '../form-section';

import formStyles from '../../styles.module.scss';

interface EligibleCruiseLinesSectionProps {
  lines: string[];
}

export function EligibleCruiseLinesSection({
  lines,
}: EligibleCruiseLinesSectionProps): React.ReactElement {
  const intl = useIntl();

  return (
    <FormSection
      title={intl.formatMessage({ id: 'certificates.payment.importantInfo' })}
      dividerAfter
    >
      <p className={formStyles.eligibleIntro}>
        {intl.formatMessage({ id: 'certificates.payment.eligibleCruiseIntro' })}
      </p>
      <ul className={formStyles.list}>
        {lines.map((line, index) => (
          <li key={`${line}-${index}`}>{line}</li>
        ))}
      </ul>
    </FormSection>
  );
}
